import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react'
import swal from 'sweetalert'
import LoadingSpinner from '../LoadingSpinner';
import { useGetAllStationsQuery } from '../../Features/stationsSlice';
import Select from 'react-select';
import { useCreateRouteMutation } from '../../Features/RoutesSlice';
import { useGetSystemRegionsForRoutesQuery } from '../../Features/regionSlice';
import LoadingBar from "react-top-loading-bar";
import { useIsOnline } from 'react-use-is-online';

function AddRouteView() {
    const navigate = useNavigate();

    const [start_off, setStart_off] = useState({});
    const [destination, setDestination] = useState({});
    const [region, setRegion] = useState({});
    const [progress, setProgress] = useState(0);
    const { isOnline } = useIsOnline();

    const [errors, setErrors] = useState({
        start_off: '',
        destination: '',
        region: '',
    })

    const {
        data: stations,
        isLoading,
        isSuccess,
        isError,
        error
      } = useGetAllStationsQuery()

      const {
        data: regions,
        isLoading: isLoadingRegions,
        isSuccess: isSuccessRegions,
        isError: isErrorRegions,
        error: errorRegions
      } = useGetSystemRegionsForRoutesQuery()

    useEffect(()=>{
            setProgress(40)
        if(isLoading){
            setProgress(60)
        }if(isLoadingRegions) {
            setProgress(80)
        }if(isSuccess && isSuccessRegions) {
            setProgress(100)
        }else{
            setProgress(100);
        }
        return () =>{
        }
    },[regions,stations])

    const [createRoute, isLoadingCreateRoute] = useCreateRouteMutation()

    const handleSubmit = async(e)=>{
        e.preventDefault();
        if(!isOnline){
            return swal("No Internet connection",'Please check Internet connection and try again'); 
        }
        const data = {
            start_off: start_off.value,
            destination: destination.value,
            region: region.value,
        }
        try {
            setProgress(80)
            const resp = await createRoute(data).unwrap()
            if(resp.hasOwnProperty('success') == true){
                setProgress(100)
                return navigate(-1);
            }
        } catch (err) {
            setProgress(100)
            if(err.data.hasOwnProperty('errors') == true){
                setErrors({...errors, start_off: err.data.errors.start_off, 
                    destination: err.data.errors.destination,
                    region: err.data.errors.region,
                })
            }else if (err.data.hasOwnProperty('error') == true){
                setProgress(100)
                swal("Error",err.data.error,"error");
            }
        }           
    }

    const back = ()=> {
        if(!isOnline){
            return swal("No Internet connection",'Please check Internet connection and try again'); 
        }
        setProgress(100)
        navigate(-1)
    };

return (
            <div className="md:w-2/5 mb-12">
                <LoadingBar
                color="#14b8a6"
                height="4px"
                progress={progress}
                onLoaderFinished={() => setProgress(0)}
                />
                {
                    (isSuccess && isSuccessRegions)?
                        <div class="bg-white shadow-md rounded-md flex flex-col justify-center">
                                <div class="p-3">
                                    <form onSubmit={handleSubmit} autoComplete="off" >
                                        <div class="divide-y divide-gray-200">
                                            <div class="py-8 text-base leading-6 space-y-4 text-gray-700 sm:text-lg sm:leading-7">
                                            <div class="col-span-6 sm:col-span-3 spax">
                                                <label for="name" class="block p-2 text-xs text-gray-500">Pick up</label>
                                                <Select 
                                                    class=""
                                                    placeholder='Search...'
                                                    options={stations}
                                                    isSearchable
                                                    onChange={setStart_off}
                                                />
                                                <p className="block text-sm font-medium text-red-600 p-0 m-0">{errors.start_off}</p>
                                            </div>
                                            <div class="col-span-6 sm:col-span-3 spax">
                                                <label for="name" class="block p-2 text-xs text-gray-500">Destination</label>
                                                <Select 
                                                    class=""
                                                    placeholder='Search...'
                                                    options={stations}
                                                    isSearchable
                                                    onChange={setDestination}
                                                />
                                                <p className="block text-sm font-medium text-red-600 p-0 m-0">{errors.start_off}</p>
                                            </div>
                                            <div class="col-span-6 sm:col-span-3 spax">
                                                <label for="name" class="block p-2 text-xs text-gray-500">Region</label>
                                                <Select 
                                                    class=""
                                                    placeholder='Search...'
                                                    options={regions.data}
                                                    isSearchable
                                                    onChange={setRegion}
                                                />
                                                <p className="block text-sm font-medium text-red-600 p-0 m-0">{errors.start_off}</p>
                                            </div>
                                            </div>
                                            <div class="pt-4 flex items-end space-x-4">
                                                <div onClick={back} class="flex cursor-pointer hover:bg-gray-50 justify-center items-center w-full text-gray-900 px-4 py-3 rounded-md focus:outline-none">
                                                    Cancel
                                                </div>
                                                <button type='submit' class="bg-green-500 flex justify-center items-center w-full text-white px-4 py-3 rounded-sm hover:shadow-md focus:outline-none">Save</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                    :null
                }
            </div>
        )
}

export default AddRouteView;
